import {ChangeDetectorRef, Component, Inject, OnChanges, OnDestroy, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {Subscription} from 'rxjs';
import {NbDialogRef, NbDialogService} from '@nebular/theme';
import {PreviewTableComponent} from '../preview-table/preview-table.component';
import {MainPageComponent} from '../../../../../main/components/main/main-page.component';
import {IDataSourcePreview, OracleBodyReq} from '../../interfaces/i-data-source-preview';
import {
  ConfigConnectionForm,
  ConfigConnectionFormConnectiopnTypes
} from '../../../../models/config-connection-form.model';
import {ConnectionForm} from '../../../../models/connection-form.model';
import {SubmitType} from '../../../../models/submit.type';
import {Connection} from '../../../../../main/modules/management/models/Connection.model';
import {ConnectionTables} from '../../../../models/connection-tables.model';
import {OracleConnection} from '../../../../../data-source/models/oracle-connection.model';
import {SqlServerConnection} from '../../../../../data-source/models/sql-server-connection.model';
import {ReplaceDataSourceConfirmUpdateComponent} from '../../../../../data-source/components/dialogs/replace-data-source-confirm-update/replace-data-source-confirm-update.component';
import {take} from 'rxjs/operators';
import {DataSourceFacade} from '../../../../../data-source/facade/data-source.facade';
import {DATA_UPDATE_FORM_CONST} from "./data-update-settings.form";
import {DataSource} from "../../../../../data-source/models/data-source.modol";
import {IncrementalSettingModel} from "../../../../../data-source/models/incremental-setting.model";

enum UpdateTypeEnum {
  INCREMENTAL = 'INCREMENTAL',
  FULL = 'FULL'
}

@Component({
  selector: 'tart-data-update-settings',
  templateUrl: './data-update-settings.component.html',
  styleUrls: ['./data-update-settings.component.scss'],
})
export class DataUpdateSettingsComponent implements OnInit, OnDestroy {
  workspaceId: string;
  dataSourceId: string;
  currentDatasourceName: string;
  type: ConfigConnectionFormConnectiopnTypes;
  configuration: Partial<ConfigConnectionForm> = {};
  validForm: boolean;
  formValues: Partial<ConnectionForm>;
  connections: Partial<Connection>[];
  connection: Partial<OracleConnection | SqlServerConnection>;
  sqlConnection: Partial<SqlServerConnection>
  connectionTables: Partial<ConnectionTables>;
  submitState: SubmitType;
  observables = [];
  subscriptions: Subscription[] = [];
  loading = false;
  dataBaseForm: FormGroup = DATA_UPDATE_FORM_CONST.createForm();
  dataUpdateType: UpdateTypeEnum = UpdateTypeEnum.FULL
  updateTypeEnum = UpdateTypeEnum
  idColumns = []
  dataSource: DataSource;
  isIncremental: boolean;
  timeModeList = [
    // {id: 'None', name: 'هیچ کدام'},
    {id: 'Minute', name: 'دقیقه'},
    {id: 'Hour', name: 'ساعت'},
    {id: 'Day', name: 'روز'},
    {id: 'Week', name: 'هفته'},
    {id: 'Month', name: 'ماه'},
    {id: 'Year', name: 'سال'},
  ];
  timeMap = {
    Minute: 'دقیقه',
    Hour: 'ساعت',
    Day: 'روز',
    Week: 'هفته',
    Month: 'ماه',
    Year: 'سال',
  };

  constructor(
    private formBuilder: FormBuilder,
    private dialogRef: NbDialogRef<MainPageComponent>,
    private dialogService: NbDialogService,
    private dataSourceFacade: DataSourceFacade,
    @Inject('DataSourcePreview') private dataSourcePreviewFacade: IDataSourcePreview,
    private changeDetectorRef: ChangeDetectorRef
  ) {
  }

  ngOnInit() {
    setTimeout(() => {
      this.dataUpdateType = this.isIncremental ? this.updateTypeEnum.INCREMENTAL : this.updateTypeEnum.FULL;
      this.dataBaseForm.controls['dataUpdateType'].setValue(this.dataUpdateType);
      this.changeFormValidations();
    }, 100);
    this.loadDataConnection();
    this.configurationForm();
    this.setSubscribers();
    // if (this.type === 'ReplaceSqlServer') {
    //   this.dataSourceFacade.checkDeleteDataSource(this.workspaceId, [this.dataSourceId]);
    // }
  }

  changeConnectionType(selectedDataUpdateType: UpdateTypeEnum) {
    this.dataUpdateType = selectedDataUpdateType;
    this.changeFormValidations();
  }

  changeFormValidations() {
    const formItems = ['id', 'updated', 'count', 'timeMode']
    formItems.forEach(formKey => {
      this.dataBaseForm.get(formKey)[this.dataUpdateType === UpdateTypeEnum.INCREMENTAL ? 'addValidators' : 'removeValidators'](Validators.required);
      this.dataBaseForm.get(formKey).updateValueAndValidity();
    });
  }


  toggleRowLimited(limited: boolean): void {
    this.dataBaseForm.controls.hasRowLimited.setValue(limited);
    if (limited) {
      this.dataBaseForm.controls.numberOfRowLimited.enable();
      this.dataBaseForm.controls.numberOfRowLimited.setValue(this.sqlConnection.numberOfRowLimited);
    } else {
      this.dataBaseForm.controls.numberOfRowLimited.setValue('');
      this.dataBaseForm.controls.numberOfRowLimited.disable();
    }
  }

  toggleTopN(limited: boolean): void {
    this.dataBaseForm.controls.hasTopN.setValue(limited);
    if (limited) {
      this.dataBaseForm.controls.numberOfTopN.enable();
      this.dataBaseForm.controls.numberOfTopN.setValue(this.sqlConnection.numberOfTopN);
    } else {
      this.dataBaseForm.controls.numberOfTopN.setValue('');
      this.dataBaseForm.controls.numberOfTopN.disable();
    }
  }

  changeSelectedConnection(evt: any) {

  }


  loadDataConnection(): void {
    if (this.type === 'EditSqlServer') {
      this.loading = true;
      this.dataSourcePreviewFacade.loadSqlServerConnection(this.workspaceId, this.dataSourceId);
    } else if (this.type === 'EditOracle') {
      this.loading = true;
      this.dataSourcePreviewFacade.loadOracleConnection(this.workspaceId, this.dataSourceId);
    }

    // if(this.dataSource.isIncremental){
    this.dataSourcePreviewFacade.loadIncrementalSetting(this.workspaceId, this.dataSourceId);
    // }
  }

  configurationForm(): void {
    // this.configuration = {
    //   formType: this.type,
    //   hasName: true,
    //   name: 'نام منبع داده',
    //   hasConnectionKind: true,
    //   hasConnectionType: true,
    //   hasConnectionList: false,
    //   hasSelectTable: false,
    //   hasServer: true,
    //   hasServiceName: true,
    //   serviceName: 'نام پایگاه داده',
    //   hasWindowsAuthentication: true,
    //   hasUserAuthentication: true,
    //   hasCommandTimeout: true,
    //   hasStatement: true,
    //   titleStatement: 'پرس و جو (Query Statement)',
    // };
    // if (this.type === 'EditSqlServer' || this.type === 'CreateSqlServer' || this.type === 'ReplaceSqlServer') {
    this.dataSourcePreviewFacade.loadUserDataBaseConnections(this.workspaceId);
    // }
  }


  setSubscribers(): void {
    this.subscriptions.push(this.dataSourcePreviewFacade.getSubmitState$().subscribe(
      (submitState) => {
        this.submitState = submitState;
        if (submitState === 'submitted') {
          // if (this.type === 'EditOracle' || this.type === 'EditSqlServer') {
            this.dataSourcePreviewFacade.setSubmitState('notSubmitted');
            this.dialogRef.close(this.sqlConnection?.name);
          // }
        }
      },
    ));
    if (this.type === 'EditSqlServer' || this.type === 'CreateSqlServer' || this.type === 'ReplaceSqlServer') {
      this.subscriptions.push(this.dataSourcePreviewFacade.getConnections$().subscribe(
        (connections) => this.connections = connections));
      this.subscriptions.push(this.dataSourcePreviewFacade.getConnectionTables$().subscribe(
        (connectionTables) => {
          this.connectionTables = connectionTables;
        }));
    }
    if (this.type === 'EditSqlServer') {
      this.subscriptions.push(this.dataSourcePreviewFacade.getSqlServerConnection$().subscribe(sqlServerConnection => {
        if (sqlServerConnection !== null) {
          this.loading = false;
          this.connection = sqlServerConnection;
          this.sqlConnection = sqlServerConnection;
          // if (sqlServerConnection.hasRowLimited) {
          //   this.toggleRowLimited(sqlServerConnection.hasRowLimited);
          // }
          // if (sqlServerConnection.hasTopN) {
          //   this.toggleTopN(sqlServerConnection.hasTopN);
          // }
          const {hasTopN, hasRowLimited, numberOfTopN, numberOfRowLimited} = sqlServerConnection;
          const formPayload = {
            hasTopN,
            hasRowLimited,
            numberOfRowLimited,
            numberOfTopN,
          };
          this.dataBaseForm.patchValue(formPayload);
          if (sqlServerConnection.dbConnectionId != null) {
            this.dataSourcePreviewFacade
              .loadDataBaseConnectionTables(this.workspaceId, sqlServerConnection.dbConnectionId);
          }
        }
      }));
    } else if (this.type === 'EditOracle') {
      this.subscriptions.push(this.dataSourcePreviewFacade.getOracleConnection$().subscribe(oracleConnection => {
        if (oracleConnection !== null) {
          this.loading = false;
          this.connection = oracleConnection;
        }
      }));
    }

    if (this.isIncremental) {
      this.subscriptions.push(this.dataSourcePreviewFacade.getIncrementalSetting$().subscribe(incrementalSetting => {
        this.dataBaseForm.patchValue(incrementalSetting)
      }))
    }
  }

  submit(): void {
    if (this.dataUpdateType === UpdateTypeEnum.INCREMENTAL) {
      const {timeMode, count, id, updated, deleted} = this.dataBaseForm.getRawValue()
      this.dataSourcePreviewFacade.updateIncrementalSetting(this.workspaceId, this.dataSourceId, id, updated,
        deleted, timeMode, count, true);
      // this.closeDialog();
    }else{
      const {timeMode, count, id, updated, deleted} = this.dataBaseForm.getRawValue()
      this.dataSourcePreviewFacade.updateIncrementalSetting(this.workspaceId, this.dataSourceId, id, updated,
        deleted, timeMode, count, false);
      this.updateSqlServer();
    }
    // if (this.type === 'CreateSqlServer') {
    //   this.createSqlServer();
    // } else if (this.type === 'CreateOracle') {
    //   this.createOracle();
    // } else if (this.type === 'EditSqlServer') {
    //   this.updateSqlServer();
    // } else if (this.type === 'EditOracle') {
    //   this.updateOracle();
    // } else if (this.type === 'ReplaceSqlServer') {
    //   this.replaceSqlServer();
    // }
  }

  private s() {

  }

  createSqlServer(): void {
    const sqlFromValues = this.formValues;
    if (sqlFromValues.connectionType === 'Queryable') {
      this.dataSourcePreviewFacade.createSqlServerConnection(this.workspaceId, sqlFromValues.name,
        sqlFromValues.serverAddress, sqlFromValues.portNumber, sqlFromValues.dbName, sqlFromValues.windowsAuth,
        sqlFromValues.username, sqlFromValues.password, sqlFromValues.commandTimeout,
        sqlFromValues.connectionStatement);
    } else if (sqlFromValues.connectionType === 'Selectable') {
      this.dataSourcePreviewFacade
        .createSqlServerDataBaseConnection(
          this.connectionTables.tables[sqlFromValues.selectedConnectionTable],
          this.connectionTables.dbConnectionId,
          this.workspaceId, sqlFromValues.name,
          sqlFromValues.hasRowLimited,
          sqlFromValues.numberOfRowLimited,
          sqlFromValues.hasTopN,
          sqlFromValues.numberOfTopN,
        );
    }
  }

  updateSqlServer(): void {
    const sqlFromValues:any = this.sqlConnection;
    const hasRowLimited = this.dataBaseForm.get('hasRowLimited').value;
    const numberOfRowLimited = this.dataBaseForm.get('numberOfRowLimited').value;
    if (sqlFromValues.connectionType === 'Queryable') {
      this.dataSourcePreviewFacade.updateSqlServerConnection(this.workspaceId, this.dataSourceId,
        this.connection.connectionId, sqlFromValues.name, sqlFromValues.serverAddress,
        sqlFromValues.portNumber, sqlFromValues.dbName, sqlFromValues.windowsAuth,
        sqlFromValues.username, sqlFromValues.password,hasRowLimited?numberOfRowLimited:0, hasRowLimited, sqlFromValues.commandTimeout,
        sqlFromValues.sqlStatement);
    } else if (sqlFromValues.connectionType === 'Selectable') {
      this.dataSourcePreviewFacade
        .updateSqlServerDataBaseConnection(
          this.workspaceId,
          this.dataSourceId,
          this.connection.connectionId,
          this.connectionTables.dbConnectionId,
          sqlFromValues.name,
          this.connectionTables.tables[this.sqlConnection.tableName],
          hasRowLimited,
          hasRowLimited?numberOfRowLimited:0,
          sqlFromValues.hasTopN,
          sqlFromValues.numberOfTopN);
    }
  }

  createOracle(): void {
    const oracleFormValue = this.formValues;
    const oracleBodyReq: Partial<OracleBodyReq> = {
      commandTimeout: oracleFormValue.commandTimeout,
      dataSourceId: this.dataSourceId,
      name: oracleFormValue.name,
      oracleConnectionType: oracleFormValue.oracleConnectionType,
      oracleAuthenticationType: oracleFormValue.windowsAuth ? 'OperatingSystemAuthentication' : 'OracleAuthentication',
      password: oracleFormValue.password,
      portNumber: oracleFormValue.portNumber,
      serverAddress: oracleFormValue.serverAddress,
      serviceIdentity: oracleFormValue.serviceIdentity,
      sqlStatement: oracleFormValue.connectionStatement,
      username: oracleFormValue.username,
      workspaceId: this.workspaceId,
    };

    this.dataSourcePreviewFacade.createOracleConnection(oracleBodyReq);
  }

  updateOracle(): void {
    const oracleFormValue = this.formValues;
    const oracleBodyReq: Partial<OracleBodyReq> = {
      commandTimeout: oracleFormValue.commandTimeout,
      dataSourceId: this.dataSourceId,
      name: oracleFormValue.name,
      oracleConnectionType: oracleFormValue.oracleConnectionType,
      oracleAuthenticationType: oracleFormValue.windowsAuth ? 'OperatingSystemAuthentication' : 'OracleAuthentication',
      password: oracleFormValue.password,
      portNumber: oracleFormValue.portNumber,
      serverAddress: oracleFormValue.serverAddress,
      serviceIdentity: oracleFormValue.serviceIdentity,
      sqlStatement: oracleFormValue.connectionStatement,
      username: oracleFormValue.username,
      workspaceId: this.workspaceId,
    };

    this.dataSourcePreviewFacade.updateOracleConnection(oracleBodyReq);
  }

  replaceSqlServer(): void {
    const sqlFromValues = this.formValues;
    if (sqlFromValues.connectionType === 'Queryable') {
      this.dataSourcePreviewFacade.replaceExcellWithSqlServerConnection(
        this.currentDatasourceName,
        this.dataSourceId,
        this.workspaceId,
        sqlFromValues.name, sqlFromValues.serverAddress,
        sqlFromValues.portNumber, sqlFromValues.dbName,
        sqlFromValues.windowsAuth, sqlFromValues.username,
        sqlFromValues.password, sqlFromValues.commandTimeout,
        sqlFromValues.connectionStatement);
    } else if (sqlFromValues.connectionType === 'Selectable') {
      this.dataSourcePreviewFacade
        .replaceExcellWithSqlServerDataBaseConnection(
          this.currentDatasourceName,
          this.dataSourceId,
          this.connectionTables.tables[sqlFromValues.selectedConnectionTable],
          this.connectionTables.dbConnectionId,
          this.workspaceId,
          sqlFromValues.name,
          sqlFromValues.hasRowLimited,
          sqlFromValues.numberOfRowLimited,
          sqlFromValues.hasTopN,
          sqlFromValues.numberOfTopN,
        );
    }
  }

  checkValidator($event): void {
    this.validForm = $event != null;
    this.formValues = $event;
  }

  loadConnectionTables(connection: Partial<Connection>) {
    if (connection != null) {
      this.dataSourcePreviewFacade.loadDataBaseConnectionTables(this.workspaceId, connection.id);
    } else {
      this.dataSourcePreviewFacade.resetConnectionTables();
    }
  }

  replaceSqlDialog() {
  }

  closeDialog(): void {
    this.dialogRef.close(false);
  }

  ngOnDestroy() {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }
}
